export default "__VITE_ASSET__a9b6deae__"